module.exports = __webpack_public_path__ + "img/upload-icon.ccdded5e.svg";